import { useState, useEffect } from "react"
import { signIn } from "../bms"

export const useBmsAuth = () => {
   const [token, setToken] = useState(null)
   const [loading, setLoading] = useState(false)
   useEffect(() => {
      const getToken = async () => {
         if (token || loading) return;
         setLoading(true)
         const data = await signIn()
         setToken(data.auth_token)
         setLoading(false)
      }
      console.log('render')
      getToken()
   }, [])
   return token
}